<template>
  <div>
      <div class="keyword-box" v-show="type=='key'">
        <div class="keyword-wrap">
            <span v-for="(item) in box" :key="item"> {{item}}
            <div class="keyword-remove" @click="keywordRemove(item,type)">
                <span></span><span></span>
            </div>
            </span>
        </div>
        <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.box')}" :ref="box" @input="keywordInput(writeKey, type)" @change="keywordChange(writeKey, type)"  v-model="writeKey" placeholder="키워드를 입력해주세요." v-validate="''"  name="updId" style="width: 100%"/>
        <span v-show="errors.has('edit.box')" class="invalid-feedback">{{ errors.first('edit.box') }}</span>
    </div>
    <div class="keyword-box"  v-show="type=='tag'">
        <div class="keyword-wrap">
            <span v-for="(item) in box" :key="item"> {{item}}
            <div class="keyword-remove" @click="keywordRemove(item,type)">
                <span></span><span></span>
            </div>
            </span>
        </div>
        <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.box')}" :ref="box" @input="keywordInput(writeTag, type)" @change="keywordChange(writeTag, type)"  v-model="writeTag" placeholder="태그를 입력해주세요." v-validate="''"  name="updId" style="width: 100%"/>
        <span v-show="errors.has('edit.box')" class="invalid-feedback">{{ errors.first('edit.box') }}</span>
    </div>
    <div class="keyword-box"  v-show="type=='category'">
        <div class="keyword-wrap">
            <span v-for="(item, idx) in box" :key="item"> {{item}}
            <div class="keyword-remove" @click="keywordRemove(item,type,idx)">
                <span></span><span></span>
            </div>
            </span>
        </div>
        <select class="custom-select custom-select-sm" @change="keywordChange(cateData.cateValue, type)" v-model="cateData.cateValue" name="srchType" style="width: 98%">
          <option value="" selected disabled>{{ !!catePlaceHolder ? catePlaceHolder : '카테고리를 선택해주세요.' }}</option>
          <option v-for="(option, index) in cateData.cateOptions" :value="option.value" :key="index">
            {{ option.text }}
          </option>
        </select>
        <span v-show="errors.has('edit.box')" class="invalid-feedback">{{ errors.first('edit.box') }}</span>
    </div>
  </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment';

export default {
  props: {
    box: '',
    boxText: '',
    type:'', // key, tag, category
    id:'', // type중복이 있을 경우를 위해.
    cateOptions:'',
    catePlaceHolder:'',
    boxLimit:'',
  },
  components: {Datepicker},
  setup(props, context) {
    //const data = props.data;
    
    const cbox = ref([]); //키워드 박스
    const cboxText = ref(''); 
    const boxLimit = props.boxLimit;

    const writeKey = ref('');
    const writeTag = ref('');

    // const cateOptions = [{value: 'contTitle', text: '제목'}, {value: 'contSeq', text: '콘텐츠 ID'}]
    // const cateOptions = _.cloneDeep(props.cateOptions);
    const cateOptions = props.cateOptions;
    let cateValue = '';
    const cateData = ref({cateOptions, cateValue});

    const type = props.type;
    const id = props.id;

    const loadData = async()=>{
      if(props.boxText != ''){
        if(type=="key"){
          keywordChange(cboxText , type);
        }else{
          keywordChange(cboxText , type);
        }
      }
    }

    const keywordInput = (data , type) =>{
      if (data.length > 0) {
        let text = _.cloneDeep(data);
        text = text.replace(/[# ;]/g, '');
        if (type == 'key') {
          writeKey.value = text;
        } else { // tag
          writeTag.value = text;
        }
      }
    }

    const keywordChange = (data , type) =>{
      if(data != ''){
        let text = _.cloneDeep(data);
        let code = text; // for category
        if (type == 'category' && text.length > 0) text = cateData.value.cateOptions.find(e => e.value == code).text;
        cbox.value = props.box;
        cboxText.value = props.boxText;

         if(text == '' || text.value==''){
            context.emit('keywordChange',cbox.value, cboxText.value ,type, id );
         }
         else{
            if(text.charAt(text.length-1) != ',' ){
                if(cboxText.value.charAt(cboxText.value.length-1) != ','){
                  cboxText.value = cboxText.value+',';
                }
                text = text+',';
            }

            cbox.value.map ((row , i)=>{
                if(text.indexOf(row) >= 0){
                    text = text.replace(row+',','');
                }
            });
            if(text != ''){
                if (type == 'category') {
                    cboxText.value += code ;
                    cboxText.value = cboxText.value.replace(/^,/,'');
                    cbox.value = cboxText.value.split(',').map(code => cateData.value.cateOptions.find(opt => opt.value == code).text);
                } else {
                    cboxText.value += text ;
                    cbox.value = _.cloneDeep(cboxText.value.split(',')); 
                }
            }

            if(text.charAt(text.length-1) == ',' ){  // 마지막 
                cbox.value.map ((row , i)=>{
                    if(row == ''){
                        cbox.value.splice(i,1);
                    }
                });
            }
            if (!!boxLimit && cbox.value.length > boxLimit) {
              cbox.value.length = boxLimit;
              alert(`최대 등록 갯수는 ${boxLimit}개입니다.`);
            }
            context.emit('keywordChange', cbox.value, cboxText.value ,type, id );
         }
        if(type=="key"){
            writeKey.value = '';
        }else if (type=='tag'){
           writeTag.value = ''; 
        }
      }
    }

    const keywordRemove = (text , type, idx) =>{
      cbox.value = props.box;
      if (idx != undefined) {
          let arr = cboxText.value.split(',').filter(e => !!e);
          arr.splice(idx,1);
          if (arr.length == 0) {
              cboxText.value = '';
              cbox.value = [];
          } else {
              cboxText.value = arr.join(',');
              cbox.value = cboxText.value.split(',').map(code => cateData.value.cateOptions.find(opt => opt.value == code).text);
          }
      } else {
          cboxText.value = '';
          cbox.value.map ((row , i)=>{
              if(row == text){
                  cbox.value.splice(i,1);
              }
              else{
                  cboxText.value += row+',';
              }
          });
      }
      context.emit('keywordRemove', cbox.value, cboxText.value ,type, id );
    }
    onMounted(loadData);

    return {
        writeKey,
        writeTag,
        cateData,
        cbox,
        cboxText,
        keywordInput,
        keywordChange,
        keywordRemove,
      ...actions(props.data, context)
    }
  }
}

function actions(data, context) {
  function search() {
    data.params.page = 1; //검색 후 1페이지로 이동
    context.emit('search', data.params)
  }

  function reset() {
    data.params.schText = '';
   // context.emit('reset')
  }
  

  return {search, reset}
}
</script>
